<template>
  <main-layout class="pb-4">
    <div class="editor-container">
      <actions-old :recipients-count="recipients ? recipients.length : 0" />
    </div>
    <div class="editor-container">
      <div class="editor">
        <div v-show="has_errors.length">
          <errors :error="has_errors" />
        </div>
        <div v-show="!has_errors.length">
          <intro-text-editor
            :recipients="recipients"
            :loading="status === 'loading'"
            @save="save"
          />
          <draft-editor-draggable-widgets @save="save" />
        </div>
      </div>
      <div class="tools">
        <draft-editor-widgets-tools
          @save="save"
          @isClicked="waitingToScroll = true"
        />
      </div>
    </div>
    <div id="bottom" />
  </main-layout>
</template>
<script>

import IntroTextEditor from '@/components/Widgets/DraftEditor/IntroTextEditor';
import ActionsOld from '@/components/Widgets/DraftEditor/ActionsOld';
import DraftEditorDraggableWidgets from '@/components/DraftEditorDraggableWidgets';
import DraftEditorWidgetsTools from '@/components/DraftEditorWidgetsTools';
import Errors from '@/components/Widgets/DraftEditor/Errors';
import _ from 'lodash';

import { EventBus } from '@/event-bus';

export default {
  name: 'PageTemplate',

  components: {
    IntroTextEditor,
    DraftEditorDraggableWidgets,
    DraftEditorWidgetsTools,
    ActionsOld,
    Errors,
  },

  data() {
    return {
      waitingToScroll: false,
    };
  },
  computed: {
    status() {
      return this.$store.state.entries.status;
    },
    recipients() {
      const g = this.$store.state.entries.item.to_groups;
      const c = this.$store.state.entries.item.to_customers;
      if (!g || !c) return [];
      const ppl = c.map((customer) => {
        const name = [customer.first_name, customer.last_name, customer.email].filter((x) => x && x.length > 0).slice(0, 2).join(' ');
        return {
          group: false,
          name,
          object: customer,
          text: name,
        };
      });

      const groups = g.map((group) => ({
        group: true,
        name: group.name,
        object: group,
        text: group.name,
      }));
      return [...groups, ...ppl];
    },
    isnotmine() {
      const hasEntry = Object.keys(this.$store.state.entries.item).length > 0;
      const isMine = this.$store.state.account.user.profile.url === this.$store.state.entries.item.owner;
      return hasEntry && !isMine;
    },
    has_errors() {
      if (this.status === 'error') {
        return 'backError';
      }
      if (this.isnotmine) {
        if (this.userCanClone) {
          const entry = this.$store.state.entries.item;
          const ownerFullName = `${entry.owner_first_name} ${entry.owner_last_name}`;
          EventBus.$emit('confirm', {
            title: 'Make a copy.',
            message: `Would you like to make a copy of ${ownerFullName}?`,
            positiveText: 'Copy',
            callback: (confirm) => {
              if (confirm) {
                this.cloneEdit();
              } else {
                this.goToEntries();
              }
            },
          });
          return 'hasToDuplicateError';
        } return 'permissionError';
      }
      return '';
    },
    userCanClone() {
      const haveentry = Object.keys(this.$store.state.entries.item).length > 0;
      return haveentry;
    },
  },
  watch: {
    status(newval) {
      if (newval && this.waitingToScroll) {
        this.waitingToScroll = false;
        this.$scrollTo('#bottom', 500);
      }
    },
  },
  mounted() {
    this.$store.dispatch('entries/fetchData', this.$route.params.id);
  },

  methods: {
    hardSave(fields) {
      this.$store.dispatch('entries/saveItem', fields).catch(() => {
        EventBus.$emit('toast-error', 'Failed updating item, please try again in a few seconds.');
      });
    },
    // eslint-disable-next-line
    save: _.debounce(function (fields) {
      if (this.status === 'loading' || this.isnotmine) {
        return;
      }
      this.$store.dispatch('entries/saveItem', fields).catch((e) => {
        console.log('error', e);
        EventBus.$emit('toast-error', 'Failed updating item, please try again in a few seconds.');
        // WARNING: Failed update leaves unconsistent vuex module state!!!
        // Consider recovering by re-fetch or storing prev state before attempting update.
      });
    }, 500),
    cloneEdit() {
      this.$store.dispatch('entries/cloneItem', this.$route.params.id)
        .then(() => {
          this.$router.push('/entries');
        });
    },
    goToEntries() {
      this.$router.push('/entries');
    },
  },
};
</script>
<style lang="css" scoped>
.editor-container{
  display: flex;
  justify-content: center;
}
.editor{
  /* max-width: 970px; */
  width: 812px;
  /* margin: 0 auto 140px auto; */
}

@media (min-width: 1024px) {
  ::v-deep .main-layout__container{
    padding-left: 100px;
    padding-right: 26px;
  }
}

@media (max-width: 1023px) {
  ::v-deep .main-layout__container{
    padding-left: 90px;
    padding-right: 90px;
  }
}
@media (max-width: 968px) {
  ::v-deep .main-layout__container{
    padding-left: 16px;
    padding-right: 16px;
  }
}
</style>
